import { forwardRef, useImperativeHandle, useRef } from 'react';

import type { AudioPlayerHandle, AudioPlayerViewProps } from './AudioPlayer.types';

export const AudioPlayerView = forwardRef<AudioPlayerHandle, AudioPlayerViewProps>(
  function AudioPlayerView({ src, label, onTimeUpdate }, ref) {
    const audio = useRef<HTMLAudioElement>(null);

    useImperativeHandle(ref, () => ({
      seek: (seconds) => {
        if (!audio.current) return;
        audio.current.currentTime = seconds;
        void audio.current.play()?.catch(() => undefined);
      },
    }));

    return (
      <audio
        ref={audio}
        src={src}
        controls
        preload="metadata"
        aria-label={label}
        style={{ width: '100%' }}
        onTimeUpdate={(event) => onTimeUpdate?.(event.currentTarget.currentTime)}
      />
    );
  }
);
